module.exports = __webpack_public_path__ + "img/bj.c5032bf1.png";